import styles from '../../styles/products.module.css';
import SectionTitle from '../common/SectionTitle';
import { IMAGEPATH } from '../../constants/imagePath';
import ProductDeliveryRobotBoxTitle from './ProductDeliveryRobotBoxTitle';
import ProductDeliveryRobotBoxDetailAmrE from './ProductDeliveryRobotBoxDetailAmrE';
import ProductDeliveryRobotBoxDetailAmr from './ProductDeliveryRobotBoxDetailAmr';
import ServiceCases from '../common/ServiceCases';
import ProductAmrRobotCaseItem from './ProductAmrRobotCaseItem';
import { ICONPATH } from '../../constants/iconPath';
import ProductAmrRobotCardItem from './ProductAmrRobotCardItem';
import { KR } from '../../constants/localizations';
import ProductRobotDetailWrap from './ProductRobotDetailWrap';

export default function ProductAmrRobot() {
    return (
        <div className={styles.robotA}>
            <SectionTitle title={KR.label_products_logi} titleEng={KR.label_products_logi_eng} />
            <div className={styles.robotAW}>
                <ProductRobotDetailWrap image={IMAGEPATH.amrE} imageWebp={IMAGEPATH.amrEWebp} titleComponent={<ProductDeliveryRobotBoxTitle title={"아웃도어 AMR"} content={"기업별 커스터마이징이 가능한 완전 무인 자율주행 물류 운반 AMR 서비스 입니다."} style={styles.radiusRight} />}
                    detailComponent={<ProductDeliveryRobotBoxDetailAmrE />} reverse={styles.robotWReverse} />
                <span className={styles.divide}></span>
                <ProductRobotDetailWrap image={IMAGEPATH.amr} imageWebp={IMAGEPATH.amrWebp} titleComponent={<ProductDeliveryRobotBoxTitle title={"AMR"} content={"라이다 센서를 기반으로 한 물류 운반 자율주행 로봇으로, 원 프레임 구조로 구성되어 실외 험로 주행이 가능한 구동 플랫폼과 라이다·카메라 센서 퓨전 기술을 활용하여 최대 1톤까지 적재할 수 있습니다."} />}
                    detailComponent={<ProductDeliveryRobotBoxDetailAmr />} />
                <div className={styles.serviceCasesW}>
                    <ServiceCases title={KR.label_products_service} titleEng={KR.label_products_service_eng} />
                    <div className={styles.caseWrap}>
                        <ProductAmrRobotCaseItem title={KR.label_products_logi_steel} icon={ICONPATH.building} />
                        <ProductAmrRobotCaseItem title={KR.label_products_logi_car} icon={ICONPATH.storage} />
                        <ProductAmrRobotCaseItem title={KR.label_products_logi_airplane} icon={ICONPATH.airplane} />
                        <ProductAmrRobotCaseItem title={KR.label_products_logi_big} icon={ICONPATH.boxF} />
                    </div>
                    <div className={styles.cardW}>
                        <ProductAmrRobotCardItem image={IMAGEPATH.fms1} imageWebp={IMAGEPATH.fms1Webp} title={"AMR 로봇 군집 제어 솔루션"} content={"AR247 자체 개발 FMS 솔루션 기반 높은 운영 효율성 및 안전한 운영 환경 제공"} />
                        <ProductAmrRobotCardItem image={IMAGEPATH.fms2} imageWebp={IMAGEPATH.fms2Webp} title={"AMR 로봇 미션 제어 기능"} content={"다수 AMR 운영 시 AMR별 사용자 지정 미션 수행, 도착지 지정, 지정 시간 내 자동 운영 등 사용자 기반 AMR 제어권 부여"} />
                        <ProductAmrRobotCardItem image={IMAGEPATH.fms4} imageWebp={IMAGEPATH.fms3Webp} title={"AMR 로봇 상태 파악"} content={"AMR 로봇 종합 상태 정보 제공, 실시간 로봇 운영 현황 파악, 월별 운영 실적 분석 정보 제공"} />
                        <ProductAmrRobotCardItem image={IMAGEPATH.fms3} imageWebp={IMAGEPATH.fms4Webp} title={"원격 접속 중앙 제어실 지원"} content={"서비스 운영 중 에러 혹은 고장 발생 시 중앙 관제실 원격 기능을 지원하여 빠른 후속 대응 서비스 제공"} />
                    </div>
                </div>
            </div>

        </div>
    )
}
